export class NoCollabRoomNameError extends Error {
  constructor(msg: string) {
    super(msg);

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, NoCollabRoomNameError.prototype);
  }

  getErrorMessage() {
    return `No Room Name was passed when trying to establish collaboration. No collaboration was made. Passed arguments are: ${this.message}`;
  }
}
